import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface VisitedTrialsState {
  setVisitedTrials: (id: string) => void;
  visitedTrials: string[];
}

export const useVisitedTrialsStore = create<VisitedTrialsState>()(
  persist(
    (set) => ({
      visitedTrials: [],
      setVisitedTrials: (id) => set((state) => ({ visitedTrials: [...state.visitedTrials, id] })),
    }),
    {
      name: 'visited-trials',
    },
  ),
);
